import axios from 'axios'
import apiUrl from './constants'

function checkUserIP(userdata, eventname,path,payload=null) {

  let input = {
    "projectname": "Hub Ops",
    "type": "web",
    "userid": userdata.userid,
    "username": userdata.username,
    "olduserid": userdata.OldDeliveryUserOrUserId,
    "routeurl":path,
    "meta": {
      "event": eventname
    }
  }
  if(payload != null)
  {
    input.meta.data=payload
  }
  axios({
      method: 'POST',
      'url': apiUrl.iptracking_url + 'UserTracker',
      'data': input
    })
    .then(async result => {
      if (result.data.code == 100) {
        // console.log(result.data.IPAddress);
      } else {
        // console.log(result.data.message)
      }
    }, error => {
      this.$alertify.success("Unable to track IP Address");
      console.error('exception is:::::::::', error)
    });
}
export default {
  checkUserIP
}



// WEBPACK FOOTER //
// ./src/usertracker.js